import "./contact.css";
import { FaFacebookF } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa6";
import { AiOutlineYoutube } from "react-icons/ai";
import { FaWhatsapp } from "react-icons/fa6";
import loc from "../../assets/contactAssets/location.svg";
import cell from "../../assets/contactAssets/call.svg";
import time from "../../assets/contactAssets/time.svg";
import main from "../../assets/contactAssets/mail.svg";
import { LiaCopyright } from "react-icons/lia";

const ContactUs = () => (
  <>
    <div className="contactus-ultimate-container" id="contact">
      <div className="contactus-container">
        <ul>
          <h3 className="contact-header-title">Saraswati Pathashala</h3>
          <p className="contact-text">
            Nuturing young minds with quality <br /> education and personalized
            attention since 2010
          </p>
          <div className="contact-social-media">
            <a href="#fb" className="contact-sm-icon">
              <FaFacebookF />
            </a>
            <a href="#insta" className="contact-sm-icon">
              <FaInstagram />
            </a>
            <a href="#yt" className="contact-sm-icon">
              <AiOutlineYoutube />
            </a>
            <a href="#wt" className="contact-sm-icon">
              <FaWhatsapp />
            </a>
          </div>
        </ul>
        <ul>
          <h3 className="contact-quick-link-header">Quick Links</h3>
          <a href="#home">
            <li className="contact-ql-item">Home</li>
          </a>
          <a href="#about">
            <li className="contact-ql-item">About</li>
          </a>
          <a href="#courses">
            <li className="contact-ql-item">Courses</li>
          </a>
          <a href="#admission">
            <li className="contact-ql-item">Admission</li>
          </a>
          <a href="#testimonials">
            <li className="contact-ql-item">Testimonials</li>
          </a>
          <a href="#contact">
            <li className="contact-ql-item">Contact</li>
          </a>
        </ul>
        <ul>
          <h3 className="contact-quick-link-header">Courses</h3>
          <li className="contact-ql-item">Class 6 & 7</li>
          <li className="contact-ql-item">Class 8 & 9</li>
          <li className="contact-ql-item">Class 10</li>
        </ul>
        <ul>
          <h3 className="contact-quick-link-header">Contact Information</h3>
          <a href="#loc">
            <li style={{ marginBottom: "16px" }}>
              <div className="contact-info-item">
                {" "}
                <img src={loc} alt="location" className="contact-info-img" />
                Floor, D, No.2-910/23/63, First, road,
                <br /> Tilak Nagar, Kusnoor, Kalaburagi, Karnataka 585105
              </div>
            </li>
          </a>
          <a href="tel:+919876543210">
            <li style={{ marginBottom: "16px" }}>
              <div className="contact-info-item">
                <img src={cell} alt="cell" className="contact-info-img" /> +91
                98765 43210
              </div>
            </li>
          </a>
          <a href="#mailto:info@saraswathipathshala.com">
            <li style={{ marginBottom: "16px" }}>
              <div className="contact-info-item">
                <img src={main} alt="mail" className="contact-info-img" />
                info@saraswathipathashala.com
              </div>
            </li>
          </a>
          <a href="#time">
            <li style={{ marginBottom: "8px" }}>
              <div className="contact-info-item">
                <img src={time} alt="timings" className="contact-info-img" />
                Mon-Sat : 08:00 AM to 08:00 PM
              </div>
            </li>
          </a>
        </ul>
      </div>
      <hr style={{ border: "1px solid #000000" }} />
      <div className="copyrights-container">
        <div className="all-rights-reserved-copyright-icon">
          <LiaCopyright />
          <span style={{ marginLeft: "10px" }}>
            Saraswathi Pathshala All rights reserved
          </span>
        </div>
        <div>
          <span style={{ marginRight: "20px" }}>Privacy Policy</span>
          <span>Terms & Conditions</span>
        </div>
      </div>
    </div>
  </>
);

export default ContactUs;
